import { DocsPage } from '@repo/ccc-main-app-lib/src/pages/DocsPage.tsx'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/user/$userId/docs')({
  component: UserDocsPage,
})

function UserDocsPage() {
  const { userId } = Route.useParams()

  return <DocsPage userId={userId} />
}
